import { createUser, updateUser } from 'api/users';
import { debouncePartner, debounceRegional, debounceRole } from 'utils/debounces';

import type { FormType } from '..';

export const userForm: FormType = {
  createFn: createUser,
  updateFn: updateUser,
  cancelText: 'Cancelar',
  submitText: 'Salvar Usuário',
  disableText: 'Desativar Usuário',
  enableText: 'Reativar Usuário',
  successText: 'Usuário salvo com sucesso!',
  fields: [
    [
      {
        name: 'role',
        type: 'select',
        required: false,
        props: {
          placeholder: 'Buscar',
          label: 'Tipo de permissão',
          loadOptions: debounceRole,
        },
      },
    ],
    [
      {
        name: 'partner',
        type: 'select',
        required: false,
        props: {
          placeholder: 'Buscar',
          label: 'Parceiro',
          loadOptions: debouncePartner,
        },
      },
    ],
    [{
      name: 'name',
      type: 'text',
      required: true,
      props: {
        placeholder: 'Nome do usuário',
        label: 'Nome',
      },
    }],
    [{
      name: 'email',
      type: 'text',
      required: true,
      props: {
        placeholder: 'exemplo@email.com',
        label: 'Email',
      },
    }, {
      name: 'phone',
      type: 'text',
      required: true,
      mask: 'maskPhone',
      props: {
        placeholder: '(00) 9 9876-5432',
        label: 'Telefone',
      },
    }], [{
      name: 'documentNumber',
      type: 'text',
      required: true,
      mask: 'maskCpf',
      props: {
        placeholder: '000.000.000-00',
        label: 'CPF',
      },
    }, {
      name: 'regional',
      type: 'select',
      required: false,
      props: {
        placeholder: 'Buscar',
        label: 'Regional',
        loadOptions: debounceRegional,
      },
    }],
  ],
};
